import {CellItem} from "./cellItem";
import {ValidateResult} from "../../model/contentType";
import {XmlTagInfo} from "../xmlTagProvider";
import {textboxItemView} from "../../ui/items/textbox";
import {Vnode} from "mithril";

type TFontSize = 'SM'|'MD'|'LG'|'XL';

export class TextboxItem extends CellItem {

    public readonly fontSize: TFontSize;
    public readonly defaultWidthPercent: number|null;
    public readonly labelLeft: string|null;
    public readonly labelRight: string|null;
    public readonly iconLeft: string|null;
    public readonly iconRight: string|null;

    static fromXml(config: XmlTagInfo) {
        return new TextboxItem(config);
    }

    private constructor(config: XmlTagInfo) {
        super(config);
        this.fontSize = <TFontSize>config.attributes['fontSize'] ?? 'MD';
        this.defaultWidthPercent = Number(config.attributes['defaultWidthPercent'] ?? null);
        this.labelLeft = config.attributes['labelLeft'] ?? null;
        this.labelRight = config.attributes['labelRight'] ?? null;
        this.iconLeft = config.attributes['iconLeft'] ?? null;
        this.iconRight = config.attributes['iconRight'] ?? null;
    }

    getView(): Vnode {
        return textboxItemView(this);
    }

    set(value: any) {

        this.setVariable(value);
        this.updateUnknowns();
        this.form.reValidate();
    }

    validate() {
        var value = this.getVariable();
        if (!this.textValueFilled(value)) {
            return ValidateResult.errorResult();
        }
        // this.contentType is set ini init()
        return this.contentType!.validate(value);
    }

    public get inputType(): string {
        return this.contentType?.type() || 'text';
    }
}